"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxy$ = exports.proxy = void 0;
const proxy = (fn, path = []) => new Proxy(() => { }, {
    get: (target, prop, receiver) => (path.push(String(prop)), (0, exports.proxy)(fn, path)),
    apply: (target, thisArg, args) => fn(path, ...args),
});
exports.proxy = proxy;
const proxy$ = (fn, sentinel, path = []) => new Proxy({}, { get: (t, prop, r) => (prop === sentinel ? fn(path) : (path.push(String(prop)), (0, exports.proxy$)(fn, sentinel, path))) });
exports.proxy$ = proxy$;
